import { DOCUMENT } from '@angular/common'
import { inject, Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'

@Injectable({ providedIn: 'root' })
export class AuthLoginService {
  private readonly document: Document = inject(DOCUMENT)
  private _lastUrl = ''

  set lastUrl (newValue: string) {
    this._lastUrl = newValue
  }

  login() {
    const nextUrl = this._lastUrl || this.document.location.toString()
    document.location.href = `${environment.apiUrl}/auth/login?next_url=${btoa(nextUrl)}`
  }
}
